import React, { Fragment, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"

import { userLogout } from "utils"
import { addShift } from "services"
import { Button, Select } from "components"
import { openShift, updateUserAccountInfo } from "@redux"
import ScsShiftIsAlreadyOpenModal from "components/ShiftCashierStart/ScsShiftIsAlreadyOpenModal"
import classes from "./KcStartShift.module.scss"

const KcStartShift = () => {
  const dispatch = useDispatch()

  const history = useHistory()

  const {
    _id: accountId,
    cashierBranches,
    fullName,
  } = useSelector(state => state.userAccountInfo)

  const [sending, setSending] = useState(false)
  const [selectedBranch, setSelectedBranch] = useState(null)
  const [alreadyOpenShiftId, setAlreadyOpenShiftId] = useState("")
  const [openShiftIsAlreadyOpenModal, setOpenShiftIsAlreadyOpenModal] = useState(false)

  const setInitialCashierBranch = async () => {
    if (cashierBranches.length === 1) {
      const cashierBranch = cashierBranches[0]

      setSelectedBranch({
        label: cashierBranch.name,
        value: cashierBranch.branchId
      })

      return
    }

    const json =
      localStorage.getItem("defaultCashiersBranch") || "{}"

    const defaultCashiersBranch =
      JSON.parse(json)

    const defaultCashierBranch =
      defaultCashiersBranch[accountId]

    !!defaultCashierBranch &&
      setSelectedBranch(defaultCashierBranch)
  }

  const handleLogout = () => {
    userLogout()

    history.push("/")
  }

  const saveCashierBranch = () => {
    const json =
      localStorage.getItem("defaultCashiersBranch") || "{}"

    const defaultCashiersBranch =
      JSON.parse(json)

    defaultCashiersBranch[accountId] = selectedBranch

    localStorage.setItem(
      "defaultCashiersBranch",
      JSON.stringify(defaultCashiersBranch)
    )

    const selectedCashierBranch =
      cashierBranches.find(cb =>
        cb._id === selectedBranch.value
      )

    dispatch(
      updateUserAccountInfo({
        branchName: selectedBranch.label,
        branchId: selectedBranch.value,
        selectedCashierBranch
      })
    )
  }

  const handleNavigate = async () => {
    if (!selectedBranch) return

    const startCash = 0

    try {
      const response =
        await addShift({
          branchId: selectedBranch.value,
          startingCash: startCash
        })

      if (!!response.error) {
        setSending(false)

        setAlreadyOpenShiftId(response.shiftId)

        setOpenShiftIsAlreadyOpenModal(true)

        return
      }

      dispatch(
        openShift(startCash, response._id)
      )

      saveCashierBranch()

      history.push("/kiosk-languages")
    } catch (err) {
      console.log(err)

      const shiftHaveAlreadyOpen =
        err?.response?.data?.message === "Shift is already open"

      toast.error(
        shiftHaveAlreadyOpen
          ? "شیفت قبلا باز شده !"
          : "شیفت با موفقیت باز نشد"
      )

      setSending(false)
    }
  }

  useEffect(() => {
    setInitialCashierBranch()
  }, [cashierBranches])

  const branchOptions =
    cashierBranches.map(c => ({
      label: c.name,
      value: c.branchId
    }))

  return (
    <Fragment>
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          ابتدا شعبه خود را انتخاب کنید
        </div>

        <Select
          isSearchable={false}
          className={classes["select"]}
          showSearchInput={false}
          options={branchOptions}
          placeholder="شعبه های کاربر"
          onChange={(select) => setSelectedBranch(select)}
          value={selectedBranch}
        />

        <div className={classes["footer"]}>
          <Button
            color="success"
            loading={sending}
            onClick={handleNavigate}
          >
            شروع شیفت
          </Button>

          <Button
            color="danger"
            disabled={sending}
            className={classes["button"]}
            onClick={handleLogout}
          >
            خروج
          </Button>
        </div>

        <div className={classes["fullname"]}>
          {fullName}
        </div>
      </div>

      <ScsShiftIsAlreadyOpenModal
        startCash={0}
        alreadyOpenShiftId={alreadyOpenShiftId}
        openShiftIsAlreadyOpenModal={openShiftIsAlreadyOpenModal}
        setOpenShiftIsAlreadyOpenModal={setOpenShiftIsAlreadyOpenModal}
      />
    </Fragment>
  )
}

export default KcStartShift